import { Injectable } from '@angular/core'
import { LocalStorageService } from '../utils'
import { Observable } from 'rxjs'
import { io, Socket } from 'socket.io-client'
import { environment } from '../../../environments/environment'

@Injectable({
    providedIn: 'root',
})
export class SocketService {
    socket: Socket
    private readonly SERVER_URL = environment.apiUrl

    constructor(localStorageService: LocalStorageService) {
        this.socket = io(this.SERVER_URL, {
            query: {
                token: localStorageService.accessToken,
            },
        })
    }

    emit(eventName: string, data: any): void {
        this.socket.emit(eventName, data)
    }

    on(eventName: string): Observable<any> {
        return new Observable<any>((observer) => {
            this.socket.on(eventName, (data: any) => {
                observer.next(data)
            })
            // Cancel events when not needed
            return () => this.socket.off(eventName)
        })
    }

    disconnect(): void {
        if (this.socket) {
            this.socket.disconnect()
        }
    }
}
